export { ProductCardFooter } from './product-card-footer'
export type { ProductCardFooterProps } from './product-card-footer'
